<template>
  <div class="container-fluid mt-8">
    <div class="row">
      <div class="col-md-4">
        <file-multiple-input accept="text/xml,application/pdf" title="Carga de archivos XML Siti AA"
          @onUpload="readFileHandler" :params="{
            reportType: 'operacionesIlicitas'
          }" :upload-uri="'/api/sitiaa/find-match'" />
      </div>
      <div class="col-md-8">

        <vx-card title="Resultados">
          <vs-table :data="readFileResponse">
            <template slot="thead">
              <vs-th>RFC</vs-th>
              <vs-th>Nombre</vs-th>
              <vs-th>Nombre archivo</vs-th>
              <vs-th>Coincidencia</vs-th>
            </template>
            <template slot-scope="{data}">
              <template v-for="result in data">
                <vs-tr v-for="i in result.results">
                  <vs-td>{{ i.persona.rfc }}</vs-td>
                  <vs-td>
                    {{
                      [
                        i.persona.name,
                        i.persona.lastName1,
                        i.persona.lastName2
                      ].join(" ")
                    }}
                  </vs-td>
                  <vs-td class="cursor-pointer underline">
                    <span @click="showDetailDialogHandler(i)">
                      {{ result.xml_file_name }}
                    </span>
                  </vs-td>
                  <vs-td class="text-center">
                    <vs-chip :color="i.hasMatches ? 'danger' : ''">
                      {{ i.hasMatches ? 'Sí coincide' : 'No coincide' }}
                    </vs-chip>
                  </vs-td>
                </vs-tr>
              </template>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>

    <vs-popup :active.sync="showSitiaaDetail" title="Expediente Siti AA">
      <pre>
    {{ currentExpedient }}
  </pre>
    </vs-popup>

  </div>
</template>

<script>

import FileMultipleInput from "@components/file-multiple-input/FileMultipleInput.vue";

export default {
  name: "XmlMatches",
  components: { FileMultipleInput },
  data: () => ({
    readFileResponse: [],
    showSitiaaDetail: false,
    currentExpedient: null
  }),
  methods: {
    readFileHandler(ev) {
      this.readFileResponse.push(ev)
    },
    showDetailDialogHandler(expediente) {
      this.showSitiaaDetail = true;
      this.currentExpedient = expediente;
    }
  }
}
</script>
